import { render } from "./ContentTags.vue?vue&type=template&id=5f785c66&scoped=true"
import script from "./ContentTags.vue?vue&type=script&lang=js"
export * from "./ContentTags.vue?vue&type=script&lang=js"

import "./ContentTags.vue?vue&type=style&index=0&id=5f785c66&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f785c66"]])

export default __exports__